import { MessageDescriptor } from "react-intl";
import { ActionType, createAction } from "typesafe-actions";

export const handleError = createAction("@errors/handleError")<{
  defaultMessage?: MessageDescriptor;
  displayNotification?: boolean;
  error: unknown;
  messageByErrorCodeMap?: Record<string, MessageDescriptor>;
}>();

export type Actions = ActionType<typeof handleError>;
